import React from "react";
import {convertToArray} from "../../Utilities/Types/arrayUtilities";

interface MapAdInfinitumProps {
    component: (child: unknown, key: string | number) => React.ReactNode;
    yutes: React.ReactNode | unknown[];
}

export const MapAdInfinitum = ({component, yutes}: MapAdInfinitumProps) => {
    const yuteArray = convertToArray(yutes);

    return yuteArray.map((child: unknown, index: number) => {
        if (!child) return null;

        const childElement = child as React.ReactElement;
        const key = childElement.key || index;

        if (childElement.type && childElement.type.toString() === React.Fragment.toString()) {
            return (childElement.props as { children: unknown[] }).children.map((grandchild: unknown, index: number) => {
                const key = childElement.key || index;
                return (
                    <MapAdInfinitum
                        key={key}
                        component={component}
                        yutes={grandchild as React.ReactNode}
                    />
                );
            });
        } else if (Array.isArray(child)) {
            return child.map((grandchild: unknown, index: number) => {
                const key = (grandchild as React.ReactElement).key || index;
                return (
                    <MapAdInfinitum
                        key={key}
                        component={component}
                        yutes={grandchild as React.ReactNode}
                    />
                );
            });
        } else if (React.isValidElement(child)) {
            return child;
        } else {
            return component(child, key);
        }
    });
};

